import React from "react";
import { Navigate } from "react-router-dom";
import { useApi } from "../Api/ApiContext";
import { useAsyncFn } from "react-use";
import {
  Row,
  Col,
  Alert,
  Button,
  Form,
  FormGroup,
  FormFeedback,
  Spinner,
} from "reactstrap";
import { useForm } from "react-hook-form";
import Input from "../component/Input";

const EmailCheckForm = ({ user }) => {
  const { sendResetPasswordEmail } = useApi();
  const [{ loading, error, value: response }, sendEmail] = useAsyncFn(
    (email) => sendResetPasswordEmail(email),
    []
  );

  const {
    register,
    handleSubmit,
    values,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    sendEmail(data.email);
  };

  if (user) {
    return <Navigate to={"/admin"} />;
  }

  if (loading) {
    return (
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Spinner color={"danger"} />
        </Col>
      </Row>
    );
  }

  if (response) {
    return (
      <div className={"my-3 my-lg-3"}>
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <p>
              Un message vous a été envoyé à l'adresse :{" "}
              <strong>{values?.email}.</strong>
            </p>
            <p>
              Cliquez sur le lien contenu dans le mail pour réinitialiser votre
              mot de passe. Si vous ne trouvez pas le mail vérifier vos spams.
            </p>
            <Alert color="info">
              <span className={"fw-bold"}>Très impportant!</span> Le lien de
              réinitialisation expirera dans 1 heure.
            </Alert>
          </Col>
        </Row>
      </div>
    );
  }

  return (
    <div className={"my-3 my-lg-3"}>
      {error && (
        <Row>
          <Col lg={6} className={"mx-auto"}>
            <Alert color="danger">
              Une erreur s'est produite. Veuillez réessayer plus tard.
            </Alert>
          </Col>
        </Row>
      )}
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <h1 className={"fs-4"}>Réinitialisez le mot de passe</h1>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <p>Un mail vous sera envoyé à l'adresse email renseignée.</p>
        </Col>
      </Row>
      <Row>
        <Col lg={6} className={"mx-auto"}>
          <Form onSubmit={handleSubmit(onSubmit)}>
            <FormGroup className={"position-relative"}>
              <label htmlFor="email" className={"form-label"}>
                Adresse email
              </label>
              <Input
                className={
                  errors.email ? "is-invalid form-control" : "form-control"
                }
                id={"email"}
                type={"text"}
                value={values?.email}
                {...register("email", {
                  required: "Ce champ est obligatoire.",
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                    message: "Le format de l'adresse e-mail n'est pas valide.",
                  },
                })}
              />
              {errors.email && (
                <FormFeedback>{errors.email.message}</FormFeedback>
              )}
            </FormGroup>
            <FormGroup
              className={"mt-5 justify-content-sm-end justify-content-around"}
              row
            >
              <Col xs={12} sm={2}>
                <Button color={"primary"} className={"w-100"} type={"submit"}>
                  Valider
                </Button>
              </Col>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default EmailCheckForm;
